// extracted by mini-css-extract-plugin
module.exports = {"backgroundColor":"#f7f7f7","imageSize":"80px"};